<template>
  <div>
    <el-form-item label="角色列表">
      <el-select
        v-model="roleValue"
        multiple
        filterable
        placeholder="输入角色名称搜索角色"
        style="width: 100%;"
        >
        <el-option
          v-for="item in roleList"
          :key="item.id"
          :label="item.name"
          :value="item.id">
          <div style="float:left;width:34px;height:34px;">
            <ImageView :src="item.avatar" style="height:24px;margin-top:5px;"></ImageView>
          </div>
          <span style="float:left;">{{ item.name }}</span>
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="用户角色" v-show="config.role == 0">
      <el-radio-group v-model="form.userRole">
        <el-radio-button :label="-1">用户选择</el-radio-button>
        <el-radio-button :label="0">系统随机选择</el-radio-button>
        <el-radio-button v-for="item in roles" :key="item.id" :label="item.id">{{item.name}}</el-radio-button>
      </el-radio-group>
    </el-form-item>
    <el-table ref="items" :data="form.items" @row-click="handleTableClick" style="width: 100%;">
      <el-table-column :index="0" type="expand" width="16">
        <template v-slot="{row}">
          <el-form-item label="角色">
            <el-radio-group v-model="row.role">
              <el-radio-button v-for="item in roles" :key="item.id" :label="item.id">{{item.name}}</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="对话文本">
            <PinyinInput v-model="row.pinyin" :text="row.text" :uppercase="true" placeholder="在这里输入对话拼音"></PinyinInput>
            <el-input v-model="row.text" style="margin-top:5px;" placeholder="在这里输入对话文本"></el-input>
          </el-form-item>
          <el-form-item label="图片" v-if="config.image">
            <ImageInput v-model="row.image" :desc.sync="row.imageDesc"></ImageInput>
          </el-form-item>
          <el-form-item label="音频">
            <FileInput v-model="row.audio" accept="audio/*"></FileInput>
          </el-form-item>
          <el-form-item label="显示类型" v-if="!config.showType">
            <el-radio-group v-model="row.showType">
              <el-radio-button :label="1">仅显示文案</el-radio-button>
              <el-radio-button :label="2">仅播放音频</el-radio-button>
              <el-radio-button :label="3">显示文案和播放音频</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="驰声语音">
            <el-input v-model="row.text_chivox"></el-input>
          </el-form-item>
          <div class="text-center">
            <el-button type="text" @click="toggleExpandItem(row)">关闭</el-button>
            <el-button type="text" @click="addItem">关闭并新增</el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column :index="1" type="index" width="50" label="#"></el-table-column>
      <el-table-column :index="2" label="角色" width="100" align="center">
         <template v-slot="{row}">
          <span>{{getRoleName(row.role)}}</span>
        </template>
      </el-table-column>
      <el-table-column :index="3" label="句子">
        <template v-slot="{row}">
          <PinyinPreview :text="row.text" :pinyin="row.pinyin"></PinyinPreview>
          <div v-show="row.text_chivox">驰声: {{row.text_chivox}}</div>
        </template>
      </el-table-column>
      <el-table-column :index="4" align="right" width="130">
        <template v-slot:header>
          <el-button type="text" icon="el-icon-plus" @click="addItem"></el-button>
          <el-button type="text" icon="el-icon-edit-outline" @click="showBatchAdd=true"></el-button>
        </template>
        <template v-slot="scope">
          <el-button @click="updateItem(scope)" type="text" size="small">编辑</el-button>
          <el-button @click="removeItem(scope.$index)" type="text" size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <ShowAnswer v-model="form" :config="config"></ShowAnswer>
    <el-dialog title="批量添加" :visible.sync="showBatchAdd" width="800px" :modal="false">
      <el-input v-model="batchText" type="textarea" :autosize="{minRows:5}" resize="none" placeholder="一行一句；格式: 角色 | 内容 | 拼音；支持从excel复制数据"></el-input>
      <div class="text-right" style="margin-top:20px;">
        <el-button @click="showBatchAdd = false">取 消</el-button>
        <el-button type="primary" @click="handleBatchAdd">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import ImageView from '../../ImageView.vue'
  import ShowAnswer from "./ShowAnswer"
  
  export default {
    name: 'DhtForm',
    components: {
      PinyinPreview: require('@/components/PinyinPreview').default,
      PinyinInput: require('@/components/PinyinInput').default,
      FileInput: require('@/components/FileInput').default,
      ImageInput: require('@/components/ImageInput').default,
      ShowAnswer,
      ImageView
    },
    props: {
      config: {},
      model: {}
    },
    data () {
      return {
        roles: [],
        roleValue: [],
        roleList: [],
        loading: false,
        form: this.createForm(this.model),
        expands: [],
        showBatchAdd: false,
        batchText: ''
      }
    },
    watch: {
      model (val) {
        this.form = this.createForm(val)
        this.initForm();
      },
      roleValue () {
        this.refreshRoles()
      }
    },
    created () {
      this.searchRemoteRoles('');
      this.initForm();
    },
    methods: {
      createForm (model) {
        let items = []
        if (model && model.items && model.items.length > 0) {
          items = model.items.map(n => this.formatMasksItem(n))
        }
        return Object.assign({}, model, {items})
      },
      initForm() {
        const roleIds = this.form && this.form.roles ? this.form.roles.map(n => n.role) : [];
        this.roleValue = roleIds.map(s => Number.parseInt(s));
      },
      refreshRoles () {
        this.roles = this.roles.filter(r => {
          return this.roleValue.includes(r.id)
        });
        let ids = this.roleValue.filter(n => {
          if (this.roles.findIndex(r => r.id == n) >= 0) {
            return false
          }
          let role = this.roleList.find(r => r.id == n)
          if (role) {
            this.roles.push(role)
            return false
          }
          return true
        })
        if (!ids || ids.length < 1) return
        this.fetchRoles({
          'filter[id]': ids,
        }).then(res => {
          ids.forEach(id => {
            let role = res.data.find(n => n.id == id)
            if (role) {
              this.roles.push(role)
              this.roleList.push(role)
            }
          })
        })
      },
      searchRemoteRoles(query) {
        this.loading = true
        this.fetchRoles({
          'filter[for_dht]': 1,
          'filter[name][like]': query || null,
        }).then(res => {
          this.roleList = res.data
          this.loading = false
        }).catch(res => {
          this.loading = false
        })
      },
      fetchRoles (params) {
        return this.$http.get(this.$urls.kewen_role_list, {
          params: Object.assign({
            page: 1,
            'per-page': 200,
          }, params)
        })
      },
      getRoleName(id) {
        let role = this.roles.find(n => n.id == id)
        return role ? role.name : ''
      },
      getInitItem() {
        let item = {role: null, text: '', pinyin: '', image: null, audio: null, text_chivox: '',
          showType: this.config.showType || 3
        }
        if (!this.config.pinyin) {
          delete item.pinyin
        }
        if (!this.config.image) {
          delete item.image
        }
        return item
      },
      addItem () {
        let item = this.getInitItem()
        this.form.items.push(item)
        this.$nextTick(() => {
          this.$refs.items.toggleRowExpansion(item)
        })
      },
      updateItem (item) {
        this.$refs.items.toggleRowExpansion(item.row)
      },
      removeItem (index) {
        this.form.items.splice(index, 1)
      },
      toggleExpandItem (item) {
        this.$refs.items.toggleRowExpansion(item)
      },
      getFormData() {
        let roleType = this.config.role
        if (roleType == 0) {
          if (this.form.userRole == 0) {
            roleType = 2
          } else if(this.form.userRole == -1) {
            roleType = 1
          } else {
            roleType = 3
          }
        }
        let roles = this.roles.map(r => {
          return { role: r.id }
        })
        return Object.assign({roleType: 3, userRole: 0, roles: []}, this.form, {
          roleType,
          roles,
          items: this.form.items.map(n => this.handleItemMasks(n)),
        })
      },
      handleItemMasks(item) {
        if (!item.text.includes('**')) return item
        let masks = []
        item.text.split(' ').forEach((s, n) => {
          if (s.includes('**')) {
            masks.push(n)
          }
        })
        item = Object.assign({}, item, {masks})
        if (!item.masks || item.masks.length === 0) {
          delete item.masks
        }
        item.text = item.text.replace('**', '')
        if (item.pinyin) {
          item.pinyin = item.pinyin.replace('**', '')
        }
        return item
      },
      formatMasksItem(item) {
        item = Object.assign({}, item)
        if (item.masks) {
          if (item.text) {
            item.text = this.formatMaskText(item.text, item.masks)
          }
          if (item.pinyin) {
            item.pinyin = this.formatMaskText(item.pinyin, item.masks)
          }
        }
        return item
      },
      formatMaskText(text, masks) {
        let parts = text.split(' ')
        masks.forEach(n => {
          parts[n] = '**' + parts[n] + '**'
        })
        return parts.join(' ')
      },
      handleTableClick(row, column, event) {
        if (column.index < 4) {
          this.toggleExpandItem(row)
        }
      },
      handleBatchAdd() {
        this.showBatchAdd = false
        let roleIndex = 0
        this.batchText.split(/\n\r|\n/).forEach(s => {
          if (/^\s*$/.test(s)) {
            return
          }
          let item = this.getInitItem()
          let items = s.split(/[\^:：\t|]/).map(s => s.trim())
          if(items.length > 1) {
            item.text = items[1]
            item.pinyin = items.length > 2 ? items[2] : ''
            if (items[0]) {
              let index = this.roles.findIndex(n => n.name == items[0])
              if (index >= 0) roleIndex = index
            }
          } else {
            item.text = items[0]
          }
          if (!item.role) {
            item.role = this.roles[roleIndex % this.roles.length].id
          }
          roleIndex++
          this.form.items.push(item)
        })
      }
    }
  }
</script>
